/* eslint-disable */

// Set up global event listener for product cards (before modal initialization)
document.addEventListener('notifyMe:open', (event) => {
  if (!event.detail?.variantId) return;
  
  const notifyMeModal = document.querySelector(".notify-me-modal");
  const form = document.querySelector(".notify-form");
  
  if (notifyMeModal) {
    if (form) {
      form.setAttribute('data-variant-id', event.detail.variantId);
    }
    notifyMeModal.style.display = "flex";
  }
});

export default function notifyMe() {
  const notifyMeModal = document.querySelector(".notify-me-modal");
  const form = document.querySelector(".notify-form");
  
  // Get inputs from within the form to ensure we're getting the right ones
  const firstNameInput = form ? form.querySelector(".notify-form-name-text[data-sharklabel='firstName']") : null;
  const lastNameInput = form ? form.querySelector(".notify-form-name-text[data-sharklabel='lastName']") : null;
  const emailInput = form ? form.querySelector(".notify-form-emailaddress-text") : null;
  const optInCheckbox = form ? form.querySelector("#marketing-opt-in") : null;
  const submitButton = form ? form.querySelector(".notify-form-send-button") : null;
  const closeButton = document.querySelector(".notify-me-modal__close-button");
  
  if (!notifyMeModal) return;
  
  // If inputs are not found, wait a bit and try again
  if (!firstNameInput || !lastNameInput || !emailInput || !submitButton) {
    setTimeout(() => {
      notifyMe(); // Retry
    }, 100);
    return;
  }

  let currentVariantId = null;

  // Helper to enable/disable submit button
  function updateSubmitButtonState() {
    if (!submitButton) return;
    
    const firstNameFilled = firstNameInput ? firstNameInput.value.trim() !== "" : false;
    const lastNameFilled = lastNameInput ? lastNameInput.value.trim() !== "" : false;
    const emailFilled = emailInput ? emailInput.value.trim() !== "" : false;
    const isValid = firstNameFilled && lastNameFilled && emailFilled;
    
    
    submitButton.disabled = !isValid;
    submitButton.style.setProperty(
      "cursor",
      isValid ? "pointer" : "not-allowed",
      "important"
    );
    submitButton.style.setProperty(
      "opacity",
      isValid ? "1" : "0.5",
      "important"
    );
    submitButton.style.setProperty(
      "background-color",
      isValid ? "" : "#ccc",
      "important"
    );
  }

  function getCurrentVariantId() {
    // Check if variant ID was set via form data attribute (from card context)
    if (form && form.dataset.variantId) {
      return form.dataset.variantId;
    }
    
    // Try to find from closest form (for card context)
    const notifyMeButton = document.querySelector(".btn--notify-me");
    if (notifyMeButton) {
      const closestForm = notifyMeButton.closest('form');
      if (closestForm && closestForm.querySelector('.product-variant-id')) {
        const variantIdInput = closestForm.querySelector('.product-variant-id');
        if (variantIdInput) {
          return variantIdInput.value;
        }
      }
    }
    
    // Product page context - look for main product form
    const productInfo = document.querySelector('product-info');
    if (productInfo) {
      const mainForm = productInfo.querySelector('form.main-product-form');
      if (mainForm) {
        const variantIdInput = mainForm.querySelector('.product-variant-id');
        if (variantIdInput) {
          return variantIdInput.value;
        }
      }
    }
    
    // Fallback to any product-variant-id on page
    const variantIdInput = document.querySelector('.product-variant-id');
    if (variantIdInput) {
      return variantIdInput.value;
    }
    
    const productSubmitButton = document.getElementById('ProductSubmitButton');
    if (productSubmitButton && productSubmitButton.dataset.variantId) {
      return productSubmitButton.dataset.variantId;
    }
    
    return null;
  }


  updateSubmitButtonState();

  if (firstNameInput) {
    firstNameInput.addEventListener("input", updateSubmitButtonState);
  }
  
  if (lastNameInput) {
    lastNameInput.addEventListener("input", updateSubmitButtonState);
  }
  
  if (emailInput) {
    emailInput.addEventListener("input", updateSubmitButtonState);
  }

  if (submitButton) {
    submitButton.addEventListener("click", (e) => {
      e.preventDefault();
      handleFormSubmit(e);
    });
  }

  function attachTriggerListener() {
    // Only attach to product page buttons (not card buttons)
    // Card buttons are handled by checkCardsAvailability.js
    const productInfo = document.querySelector('product-info');
    if (!productInfo) return; // Not on product page, skip
    
    const notifyMeButton = productInfo.querySelector(".btn--notify-me");
    if (notifyMeButton && !notifyMeButton.hasAttribute('data-card-button')) {
      const newButton = notifyMeButton.cloneNode(true);
      notifyMeButton.parentNode.replaceChild(newButton, notifyMeButton);
      newButton.addEventListener("click", (e) => {
        e.preventDefault();
        currentVariantId = getCurrentVariantId();
        showModal();
      });
    }
  }

  function showModal(variantId = null) {
    if (variantId) {
      currentVariantId = variantId;
      // Store variant ID in form for getCurrentVariantId to use
      if (form) {
        form.setAttribute('data-variant-id', variantId);
      }
    }
    notifyMeModal.style.display = "flex";
    // document.body.style.overflow = "hidden"; // Prevent background scrolling
    updateSubmitButtonState();
  }

  attachTriggerListener();

  // Listen for variant changes to update current variant (product page only)
  document.addEventListener("variant:changed", (event) => {
    if (event.detail && event.detail.variant) {
      currentVariantId = event.detail.variant.id;
    }
    attachTriggerListener();
  });

  // Close modal functionality
  function closeModal() {
    notifyMeModal.style.display = "none";
    document.body.style.overflow = ""; // Restore background scrolling
    
    // Reset form
    if (firstNameInput) firstNameInput.value = "";
    if (lastNameInput) lastNameInput.value = "";
    if (emailInput) emailInput.value = "";
    if (optInCheckbox) optInCheckbox.checked = false;
    
    // Reset variant ID from form data attribute
    if (form) form.removeAttribute('data-variant-id');
    currentVariantId = null;
    
    // Reset any success/error messages
    const existingMessages = form.querySelectorAll('div[style*="color"]');
    existingMessages.forEach(msg => msg.remove());
    
    // Show form again if it was hidden
    if (form) form.style.display = "";
    
    updateSubmitButtonState();
  }

  if (closeButton) {
    closeButton.addEventListener("click", closeModal);
  }

  notifyMeModal.addEventListener("click", (e) => {

    if (e.target.classList.contains('notify-me-modal__overlay') || e.target === notifyMeModal) {
      closeModal();
    }
  });

  async function handleFormSubmit(e) {
    e.preventDefault();

    if (!submitButton) return;

    // Get current variant ID
    const variantId = currentVariantId || getCurrentVariantId();
    
    if (!variantId) {
      console.error('No variant ID found');
      return;
    }

    // Disable submit button during submission
    submitButton.disabled = true;
    submitButton.style.cursor = "not-allowed";

    // Get form data
    const firstName = firstNameInput ? firstNameInput.value.trim() : '';
    const lastName = lastNameInput ? lastNameInput.value.trim() : '';
    const email = emailInput ? emailInput.value.trim() : '';
    const optIn = optInCheckbox ? optInCheckbox.checked : false;


    if (!klaviyoApiKey) {
      console.error('Klaviyo API key not configured');
      submitButton.disabled = false;
      return;
    }

    // Back In Stock Subscription
    const backInStockBody = {
      data: {
        type: "back-in-stock-subscription",
        attributes: {
          profile: {
            data: {
              type: "profile",
              attributes: {
                email: email,
              },
            },
          },
          channels: ["EMAIL"],
        },
        relationships: {
          variant: {
            data: {
              type: "catalog-variant",
              id: `$shopify:::$default:::${variantId}`,
            },
          },
        },
      },
    };

    const headers = {
      "Content-Type": "application/json",
      revision: klaviyoApiVersion,
    };

    const backInStockPromise = fetch(
      `https://a.klaviyo.com/client/back-in-stock-subscriptions?company_id=${klaviyoApiKey}`,
      {
        method: "POST",
        headers: {
          ...headers,
        },
        body: JSON.stringify(backInStockBody),
      }
    ).then(async (res) => {
      if (res.status !== 202) {
        const errorText = await res.text();
        console.error('Back in stock subscription failed:', res.status, errorText);
        throw new Error(`Back in stock subscription failed: ${res.status}`);
      }
    });

    let promises = [backInStockPromise];

    // Client Subscription (for marketing opt-in) - only if opt-in is checked and list ID is provided
    if (optIn && klaviyoListId) {
      const clientSubscriptionBody = {
        data: {
          type: "subscription",
          attributes: {
            profile: {
              data: {
                type: "profile",
                attributes: {
                  subscriptions: {
                    email: {
                      marketing: {
                        consent: "SUBSCRIBED",
                      },
                    },
                  },
                  email: email,
                  first_name: firstName,
                  last_name: lastName,
                },
              },
            },
          },
          relationships: {
            list: {
              data: {
                type: "list",
                id: klaviyoListId,
              },
            },
          },
        },
      };

      const clientSubscriptionPromise = fetch(
        `https://a.klaviyo.com/client/subscriptions?company_id=${klaviyoApiKey}`,
        {
          method: "POST",
          headers: {
            ...headers,
          },
          body: JSON.stringify(clientSubscriptionBody),
        }
      ).then(async (res) => {

        if (res.status !== 202) {
          const errorText = await res.text();
          console.error('Client subscription failed:', res.status, errorText);
          throw new Error(`Client subscription failed: ${res.status}`);
        }
  
      });
      promises.push(clientSubscriptionPromise);
    }

    Promise.allSettled(promises)
      .then((results) => {
     
        const allSuccessful = results.every(result => result.status === 'fulfilled');
        
        if (allSuccessful) {
          // Show success message
          const successMessage = document.createElement('div');
          successMessage.innerHTML = '<p style="font-weight: 400; margin-top: 8px;">Thanks for subscribing! We\'ll notify you when this product is back in stock.</p>';
          form.appendChild(successMessage);
          
        } else {
          // Show error message if any promise was rejected
          const errorMessage = document.createElement('div');
          errorMessage.innerHTML = '<p style="font-weight: 400;  margin-top: 8px;">Something went wrong. Please try again later.</p>';
          form.appendChild(errorMessage);
          
          // Log the specific errors
          results.forEach((result, index) => {
            if (result.status === 'rejected') {
              console.error(`Promise ${index} failed:`, result.reason);
            }
          });
        }
      })
      .catch((err) => {
        // This catch block handles any unexpected errors in the Promise.allSettled chain
        const errorMessage = document.createElement('div');
        errorMessage.innerHTML = '<p style="font-weight: 400;margin-top: 8px;">Something went wrong. Please try again later.</p>';
        form.appendChild(errorMessage);
        console.error("Unexpected error with subscription:", err);
      })
      .finally(() => {
        submitButton.disabled = false;
        submitButton.style.cursor = "pointer";
      });
  }
}